<template>
  <div id="user-list">
    <contadores
      :qtd-agentes="qtdFilasDeAtendimentoVisaoDeAgente"
      :qtd-gestores="qtdFilasDeAtendimentoVisaoDeGestor"
      @alterarFiltro="filtrar($event)"
    />

    <v-card>
      <v-card-title>Busca rápida de protocolo</v-card-title>

      <v-row class="px-2 ma-0">
        <v-col
          cols="12"
          sm="4"
        >
          <v-text-field
            v-model.trim="ticketProtocolo"
            placeholder="Digite o número do protocolo"
            outlined
            dense
            class="campos-pesquisa me-3 mb-4"
            hint="Digite apenas números"
          />
        </v-col>

        <v-col
          cols="12"
          sm="1"
          class="d-flex flex-md-row flex-column justify-space-around"
        >
          <v-btn
            color="success"
            class="me-3 mb-4"
            @click="filtrarProtocolo"
          >
            Filtrar
          </v-btn>
        </v-col>
      </v-row>

      <v-col
        cols="12"
        class="mx-auto mt-0"
      >
        <v-divider />
        <div style="min-height: 2px">
          <v-progress-linear
            v-if="loading"
            indeterminate
          />
        </div>
      </v-col>

      <v-card-title v-if="!loading">
        Filas de atendimento
      </v-card-title>

      <v-row class="px-10">
        <v-col
          v-for="(item, index) in filasDeAtendimento"
          :key="index"
          cols="4"
          sm="4"
          class="d-flex align-center"
        >
          <card-fila-atendimento
            :fila-de-atendimento="item"
            :rota-agente="rotaAgente"
            :rota-gestor="rotaGestor"
            :qtd-sla-primeira-resposta-ticket-alerta-azul="item.qtdSlaPrimeiraRespostaTicketAlertaAzul"
            :qtd-sla-primeira-resposta-ticket-alerta-verde="item.qtdSlaPrimeiraRespostaTicketAlertaVerde"
            :qtd-sla-primeira-resposta-ticket-alerta-laranja="item.qtdSlaPrimeiraRespostaTicketAlertaLaranja"
            :qtd-sla-primeira-resposta-ticket-alerta-vermelho="item.qtdSlaPrimeiraRespostaTicketAlertaVermelho"
            :qtd-sla-finalizacao-ticket-alerta-azul="item.qtdSlaFinalizacaoTicketAlertaAzul"
            :qtd-sla-finalizacao-ticket-alerta-verde="item.qtdSlaFinalizacaoTicketAlertaVerde"
            :qtd-sla-finalizacao-ticket-alerta-laranja="item.qtdSlaFinalizacaoTicketAlertaLaranja"
            :qtd-sla-finalizacao-ticket-alerta-vermelho="item.qtdSlaFinalizacaoTicketAlertaVermelho"
          />
        </v-col>
      </v-row>
    </v-card>
  </div>
</template>

<style lang="scss">
@import '@core/preset/preset/apps/user.scss';

.campos-pesquisa {
  max-width: 500px;
}
</style>

<script>
import Vue from 'vue'
import { onMounted, onBeforeUnmount, ref } from '@vue/composition-api'
import { storeToRefs } from 'pinia'
import { EventBus } from '@/components/event-bus/event-bus'
import router from '@/router'
import Contadores from '@/views/front-atendimento/Contadores.vue'
import CardFilaAtendimento from '@/views/front-atendimento/CardFilaAtendimento.vue'
import EquipeFuncaoEnum from '@/models/entities/equipe/EquipeFuncaoEnum'
import FilaService from '@/services/modules/FilaService'
import TicketService from '@/services/modules/TicketService'
import useUserStore from '@/store/user'

export default {
  components: {
    Contadores,
    CardFilaAtendimento,
  },

  setup() {
    const { id: atendenteLogadoId } = storeToRefs(useUserStore())

    const rotaAgente = 'front-atendimento-agente'
    const rotaGestor = 'front-atendimento-gestor'

    const filasDeAtendimento = ref([])
    const qtdFilasDeAtendimentoVisaoDeAgente = ref(0)
    const qtdFilasDeAtendimentoVisaoDeGestor = ref(0)

    const search = ref('')
    const filtros = ref('')
    const loading = ref(false)
    const ticketProtocolo = ref('')

    async function getAtendimentos() {
      try {
        loading.value = true

        filasDeAtendimento.value = await FilaService.getAtendimentos()

        qtdFilasDeAtendimentoVisaoDeAgente.value = filasDeAtendimento.value.filter(
          i => i.papelId === EquipeFuncaoEnum.Agente.id,
        ).length
        qtdFilasDeAtendimentoVisaoDeGestor.value = filasDeAtendimento.value.filter(
          i => i.papelId === EquipeFuncaoEnum.Gestor.id,
        ).length

        if (search.value) {
          filasDeAtendimento.value = filasDeAtendimento.value.filter(it => it.nome.toLowerCase().includes(search.value.toLowerCase()))
        }
        if (filtros.value) {
          filasDeAtendimento.value = filasDeAtendimento.value.filter(
            fila => fila.papelNome === filtros.value,
          )
        }
        setTimeout(() => {
          loading.value = false
        }, 1000)
      } catch {
        loading.value = false
      }
    }

    function onFetchTickets() {
      getAtendimentos()
    }

    onMounted(() => {
      getAtendimentos()

      EventBus.$on('fetch-tickets', onFetchTickets)
    })

    onBeforeUnmount(() => {
      EventBus.$off('fetch-tickets', onFetchTickets)
    })

    function filtrar(item) {
      filtros.value = item
      getAtendimentos()
    }

    function limparFiltros() {
      ticketProtocolo.value = null
      getAtendimentos()
    }

    async function filtrarProtocolo() {
      if (!ticketProtocolo.value) {
        Vue.$toast.error('Insira um protocolo.')
        return
      }

      try {
        loading.value = true

        const data = await TicketService.getTicketByProtocolo(ticketProtocolo.value)

        const url = router.resolve({
          name:
            data.papelId === EquipeFuncaoEnum.Gestor.id || atendenteLogadoId !== data.atendenteId
              ? rotaGestor
              : rotaAgente,
          query: { filaId: data.filaId, filaNome: data.filaNome, ticketProtocolo: ticketProtocolo.value },
        })

        window.open(url.href)
      } catch {
        Vue.$toast.error('Protocolo não localizado.')
      } finally {
        loading.value = false
        limparFiltros()
      }
    }

    const opcoes = [
      { title: 'Agente', value: 'Agente' },
      { title: 'Gestor', value: 'Gestor' },
      { title: 'Todos', value: '' },
    ]

    return {
      rotaAgente,
      rotaGestor,
      filasDeAtendimento,
      qtdFilasDeAtendimentoVisaoDeAgente,
      qtdFilasDeAtendimentoVisaoDeGestor,
      search,
      filtros,
      loading,
      ticketProtocolo,
      filtrar,
      filtrarProtocolo,
      opcoes,
    }
  },
}
</script>
